import { FilterQueryParams } from 'src/utils/types';
import request from './utils';
import * as ROUTES from 'src/api/routes';
import { DocumentScanResponse } from 'common/lib/model/documentScan/DocumentScan';
import { PaginatedResult } from 'common/lib/util/pagination';

export async function getDocumentScan(documentScanId: string): Promise<DocumentScanResponse> {
    const result = await request({ ...ROUTES.GET_DOCUMENT_SCAN, pathParams: { documentScanId } });
    return result.data.documentScan;
}

export async function getDocumentScans(
    facilityId: number,
    params: FilterQueryParams & { hasEncounter?: boolean } = {},
): Promise<PaginatedResult<DocumentScanResponse>> {
    const { hasEncounter, ...restParams } = params;
    const requestParams: any = { facilityId, ...restParams };

    if (hasEncounter !== undefined) {
        requestParams.hasEncounter = hasEncounter.toString();
    }

    if (restParams.pagination) {
        requestParams.pagination = JSON.stringify(restParams.pagination);
    }

    const result = await request({ ...ROUTES.GET_DOCUMENT_SCANS, params: requestParams });

    return { result: result.data.result || [], count: result.data.count || 0 };
}
